'use client'

import dynamic from 'next/dynamic'
import React from 'react'
import { type GliderProps } from 'react-glider/dist/types'

import 'glider-js/glider.min.css'

const Glider = dynamic(() => import('react-glider'), { ssr: false })

const GliderClient: React.FC<GliderProps> = (props) => {
  return <Glider {...props} />
}

export default GliderClient
